/**
 * Global directives object
 */
const directives = {};
export default directives;
